<div mat-dialog-title class="d-flex align-center justify-content-between mb-0">
  <h3>{{ options?.title }}</h3>
</div>
<div mat-dialog-content class="mb-20 content">
  <ol class="terms-conditions-list mt-12">
    <li>
      Acceptance of Terms:
      <ol>
        <li>
          Welcome to FleetBeat! By accessing or using FleetBeat's services, including the web application and mobile
          application, you are agreeing to these Terms of Use. If you do not agree with these terms, please refrain from
          using FleetBeat.
        </li>
      </ol>
    </li>

    <li>
      License and Site Access:
      <ol>
        <li>FleetBeat grants you a limited license to access and use the services available on the site.</li>

        <li>
          This license does not include the right to download, modify, or reproduce any part of the site without the
          express written consent of FleetBeat.
        </li>
      </ol>
    </li>

    <li>
      User Accounts:
      <ol>
        <li>
          To use certain features of FleetBeat, you may need to register and create a user account. You are responsible
          for maintaining the confidentiality of your account information.
        </li>
      </ol>
    </li>

    <li>
      Privacy:
      <ol>
        <li>
          Your privacy is important to us. FleetBeat collects and handles your personal data in accordance with our
          Privacy Policy, available on our website.
        </li>
      </ol>
    </li>

    <li>
      Use of Services:
      <ol>
        <li>You agree to use FleetBeat's services in compliance with all applicable laws and regulations.</li>

        <li>The services should not be used for any fraudulent, abusive, or illegal activities.</li>
      </ol>
    </li>

    <li>
      Intellectual Property:
      <ol>
        <li>FleetBeat's services, software, trademarks, and content are protected by intellectual property laws.</li>

        <li>You may not modify, distribute, or reproduce any part of FleetBeat without prior written consent.</li>
      </ol>
    </li>

    <li>
      Termination:
      <ol>
        <li>
          FleetBeat may terminate or suspend your account or access to the services at its discretion, with or without
          cause.
        </li>

        <li>You can terminate your account by discontinuing the use of FleetBeat's services.</li>
      </ol>
    </li>

    <li>
      Limitation of Liability:
      <ol>
        <li>
          You use FleetBeat's services at your own risk. FleetBeat and its associates will not be liable for any direct
          or indirect damages resulting from your use of the service.
        </li>
      </ol>
    </li>

    <li>
      Changes to Terms of Use:
      <ol>
        <li>
          FleetBeat reserves the right to update these Terms of Use at any time. Your continued use of the services
          after changes constitute your acceptance of the new terms.
        </li>
      </ol>
    </li>

    <li>
      Governing Law:
      <ol>
        <li>These Terms of Use are governed by and construed in accordance with the laws of USA.</li>
      </ol>
    </li>

    <li>
      Additional Legal Resources:
      <ol>
        <li>
          FleetBeat may provide additional legal documents or contracts for specific services. Usage of these services
          is governed by the terms specified at the time of initial purchase.
        </li>
      </ol>
    </li>
  </ol>
</div>

<div mat-dialog-actions class="justify-content-end">
  <button mat-button *ngFor="let button of options.buttons" [mat-dialog-close]="button?.action" class="btn-dialog">
    {{ button?.caption }}
  </button>
</div>
